import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreInitiativesDeleteAsyncSlice } from './delete';
import { coreInitiativesGetAsyncSlice } from './get';
import { coreInitiativesIdMapReducers } from './_idMap';
import { coreInitiativesPatchAsyncSlice } from './patch';
import { coreInitiativesPostAsyncSlice } from './post';

import { coreInitiativesBulkReducers, coreInitiativesBulkWatchers } from './bulk';
import { coreInitiativesByIdReducers, coreInitiativesByIdWatchers } from './_id';
import { coreInitiativesCommentsReducers, coreInitiativesCommentsWatchers } from './comments';
import { coreInitiativesExportReducers, coreInitiativesExportWatchers } from './export';
import { coreInitiativesFilesReducers, coreInitiativesFilesWatchers } from './files';
import { coreInitiativesLinksReducers, coreInitiativesLinksWatchers } from './links';
import { coreInitiativesSonarObjectsReducers, coreInitiativesSonarObjectsWatchers } from './sonar-objects';
import { coreInitiativesStatusesReducers, coreInitiativesStatusesWatches } from './statuses';
import { coreInitiativesSummaryReducers, coreInitiativesSummaryWatchers } from './summary';
import { coreInitiativesTagsReducers, coreInitiativesTagsWatchers } from './tags';
import { coreInitiativesTasksReducers, coreInitiativesTasksWatchers } from './tasks';

export const coreInitiativesReducers = combineReducers({
	bulk: coreInitiativesBulkReducers,
	byId: coreInitiativesByIdReducers,
	byIdMap: coreInitiativesIdMapReducers,
	comments: coreInitiativesCommentsReducers,
	delete: coreInitiativesDeleteAsyncSlice.asyncReducers,
	export: coreInitiativesExportReducers,
	files: coreInitiativesFilesReducers,
	get: coreInitiativesGetAsyncSlice.asyncReducers,
	links: coreInitiativesLinksReducers,
	patch: coreInitiativesPatchAsyncSlice.asyncReducers,
	post: coreInitiativesPostAsyncSlice.asyncReducers,
	sonarObjects: coreInitiativesSonarObjectsReducers,
	statuses: coreInitiativesStatusesReducers,
	summary: coreInitiativesSummaryReducers,
	tags: coreInitiativesTagsReducers,
	tasks: coreInitiativesTasksReducers
});

export const coreInitiativesWatchers = combineAllWatchers([
	coreInitiativesBulkWatchers,
	coreInitiativesByIdWatchers,
	coreInitiativesCommentsWatchers,
	coreInitiativesDeleteAsyncSlice.asyncWatchers,
	coreInitiativesExportWatchers,
	coreInitiativesFilesWatchers,
	coreInitiativesGetAsyncSlice.asyncWatchers,
	coreInitiativesLinksWatchers,
	coreInitiativesPatchAsyncSlice.asyncWatchers,
	coreInitiativesPostAsyncSlice.asyncWatchers,
	coreInitiativesSonarObjectsWatchers,
	coreInitiativesStatusesWatches,
	coreInitiativesSummaryWatchers,
	coreInitiativesTagsWatchers,
	coreInitiativesTasksWatchers
]);
